import { createContext } from 'react';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { ResultPromiseContextProvider } from 'forms-ai-lib/internal/providers/ResultPromiseContext';
import AlertStoreContextProvider, { FloatingAlertList } from 'forms-ai-lib/internal/providers/AlertStoreContextProvider';
import { ReduxStoreProvider, makeTestStoreAndProvider } from 'forms-ai-lib/internal/providers/ReduxStoreProvider';
import { ResultPromiseErrorBoundary } from 'forms-ai-lib/internal/components/errorBoundary/ResultPromiseErrorBoundary';
import { WizardContainer } from 'forms-ai-lib/internal/containers/WizardContainer';
import { useFormAIWizard } from 'forms-ai-lib/hooks/useFormAIWizard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FormsAILibContext = /*#__PURE__*/createContext({
  formsAILib: {}
});
const makeFormAIProvider = Component => ({
  children
}) => /*#__PURE__*/_jsx(ReduxStoreProvider, {
  children: /*#__PURE__*/_jsx(ResultPromiseContextProvider, {
    children: /*#__PURE__*/_jsxs(AlertStoreContextProvider, {
      children: [children, /*#__PURE__*/_jsxs(ResultPromiseErrorBoundary, {
        children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(Component, {})]
      })]
    })
  })
});
export const makeTestSetup = preloadedState => {
  const {
    store,
    Provider: TestStoreProvider
  } = makeTestStoreAndProvider(preloadedState);

  // HACK: This component exposes the useFormAIWizardResult entry point hook to
  // tests so they can open the modal like a host app would
  const useFormAIWizardResult = {
    current: null
  };
  const ExposeHookResult = () => {
    useFormAIWizardResult.current = useFormAIWizard();
    return null;
  };
  const dataFetchingClient = new DataFetchingClient();
  return {
    useFormAIWizardResult,
    store,
    wrapper: ({
      children
    }) => /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: dataFetchingClient,
      children: /*#__PURE__*/_jsx(ResultPromiseContextProvider, {
        children: /*#__PURE__*/_jsx(TestStoreProvider, {
          children: /*#__PURE__*/_jsxs(AlertStoreContextProvider, {
            children: [/*#__PURE__*/_jsx(ExposeHookResult, {}), /*#__PURE__*/_jsxs(ResultPromiseErrorBoundary, {
              children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), children]
            })]
          })
        })
      })
    })
  };
};
export const FormsAILibProvider = makeFormAIProvider(WizardContainer);